module.exports = __webpack_public_path__ + "static/media/role2.f30177c1.png";